export enum ActionTypes {
  // error handling action types
  CLEAR_ERRORS = "CLEAR_ERRORS",
  RETURN_ERRORS = "RETURN_ERRORS",
  // toys-related action types
  GET_TOY_LIST_SUCCESS = "GET_TOY_LIST_SUCCESS",
  GET_TOY_LIST_FAIL = "GET_TOY_LIST_FAIL",
  CLEAR_TOY_LIST = "CLEAR_TOY_LIST",
  GET_TOY_SUCCESS = "GET_TOY_SUCCESS",
  GET_TOY_FAIL = "GET_TOY_FAIL",
  CLOSE_TOY_PAGE = "CLOSE_TOY_PAGE",
  CREATE_TOY_SUCCESS = "CREATE_TOY_SUCCESS",
  CREATE_TOY_FAIL = "CREATE_TOY_FAIL",
  DELETE_TOY_SUCCESS = "DELETE_TOY_SUCCESS",
  DELETE_TOY_FAIL = "DELETE_TOY_FAIL",
  EDIT_TOY_SUCCESS = "EDIT_TOY_SUCCESS",
  EDIT_TOY_FAIL = " EDIT_TOY_FAIL",
  // Cloudinary image uploading for toys
  UPLOAD_TOY_IMAGE_SUCCESS = "UPLOAD_TOY_IMAGE_SUCCESS",
  UPLOAD_TOY_IMAGE_FAIL = "UPLOAD_TOY_IMAGE_FAIL",
  // loaders
  ACTION_SHOW_LOADER = "ACTION_SHOW_LOADER",
  // user-related action types
  RETRIEVE_USER_INFO_SUCCESS = "RETRIEVE_USER_INFO_SUCCESS",
  RETRIEVE_USER_INFO_FAIL = "RETRIEVE_USER_INFO_FAIL",
  REGISTER_SUCCESS = "REGISTER_SUCCESS",
  REGISTER_FAIL = "REGISTER_FAIL",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGIN_FAIL = "LOGIN_FAIL",
  LOGOUT = "LOGOUT",
  // Wiki search related action types
  ADD_WIKI_SEARCH_RETURN_VALUES_SUCCESS = "ADD_WIKI_SEARCH_RETURN_VALUES_SUCCESS",
  ADD_WIKI_SEARCH_RETURN_VALUES_FAIL = "ADD_WIKI_SEARCH_RETURN_VALUES_FAIL",
  CLEAR_WIKI_SEARCH_VALUES = "CLEAR_WIKI_SEARCH_VALUES",
}
